var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCardVaginalInfections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3643 9.87449C15.1766 12.6078 11.1876 13.0497 8.45433 10.8628C8.08984 10.5709 7.75797 10.239 7.46687 9.87449C7.32417 9.69999 7.06731 9.67472 6.89282 9.81823C6.72158 9.95848 6.69385 10.2096 6.83003 10.3841C8.09881 11.9685 9.98078 12.9404 12.0079 13.0554V20.5915C12.0079 20.8165 12.1906 20.9992 12.4156 20.9992C12.6407 20.9992 12.8233 20.8165 12.8233 20.5915V13.0554C14.8504 12.9396 16.7324 11.9685 18.0012 10.3841C18.1398 10.2064 18.1088 9.95033 17.9319 9.81171C17.7574 9.67472 17.5054 9.70244 17.3643 9.87449Z",
    fill: "#B760FF",
    stroke: "#B760FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4439 1.54912C23.7727 7.67776 23.5044 14.4905 20.7027 20.4186C20.6081 20.6224 20.6961 20.8646 20.9 20.96C21.1022 21.0538 21.3428 20.9682 21.4398 20.7668C24.337 14.6389 24.6142 7.59541 22.2055 1.25965C22.1231 1.04927 21.8866 0.946533 21.6771 1.02889C21.4708 1.10962 21.368 1.34038 21.4439 1.54912Z",
    fill: "#B760FF",
    stroke: "#B760FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12856 20.4186C1.32598 14.4905 1.05853 7.67776 3.38816 1.54912C3.46563 1.33711 3.35718 1.10309 3.14598 1.02481C2.93724 0.948978 2.70648 1.05254 2.62575 1.25965C0.217836 7.59541 0.494262 14.6389 3.39142 20.7668C3.48764 20.9698 3.73063 21.0571 3.93449 20.9608C4.13834 20.8646 4.22559 20.6216 4.12856 20.4186Z",
    fill: "#B760FF",
    stroke: "#B760FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCardVaginalInfections);
export default __webpack_public_path__ + "static/media/icon_chat_card_vaginal_infections.8cc8ff0e66d759596c18aef7378d33ee.svg";
export { ForwardRef as ReactComponent };